<template>

  <div class="overlayDiv">

    <span>{{ getAddress }}</span>

    <br/>  <br/>

    <b>MEDIODIA:</b> <span>TAKE AWAY, SALON Y DELIVERY</span><br/>
    <span>De lunes a sabados de 12HS a 15HS</span> <br/><br/>


    <b>NOCHE:</b> <span>TAKE AWAY Y SALON</span><br/>
    <span>DELIVERY todo CABA y parte GBA</span><br/>
    <span>Lunes a miércoles 18:00 a 22:30 hs. Cerramos a las 23:00 hs</span><br/>
    <span>Jueves a Domingos de 19:00 a 23:30 hs. Cerramos a las 00:00 hs</span><br/>
  </div>
</template>

<script>
export default {
  name: "HomeData",
  computed: {
    getAddress() {
      return this.$store.getters.getSettingValue("ShopAddress")
    },
    getBusinessHours() {
      return this.$store.getters.getSettingValue("businessHours")
    }
  }
}
</script>

<style scoped>
.overlayDiv {
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3); /* Fondo negro semi-transparente */
  padding: 20px;
  color: white; /* Color del texto */
  border-radius: 5px;
}
</style>
